"use client";
import ButtonV2 from "elements/ButtonV2";
import NextImage, { StaticImageData } from "next/image";
import Contact from "../../Landing/Contact";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper";
import { CaseStudies } from "components/pages/AppealsPage/CaseStudies";
import constants from "utils/constants";
import { useRef, useEffect } from "react";
import { useEventTracker } from "utils/useEventTracker";
import { useRouter } from "next/navigation";
import { useResponsiveContext } from "context/ResponsiveContext";
import QuickLink from "elements/QuickLink";

import FiveStar from "public/landing/commercial-dark/five-star.svg";
import TrustedPeople from "public/landing/commercial-dark/trusted-people.png";
import MockUpDesktop from "public/landing/commercial-dark/mock-desk.png";
import FeaturedIn from "public/landing/commercial-dark/featured-in.svg";
import SliderBG from "public/landing/commercial-dark/slider-bg-1.jpg";
import SliderBG2 from "public/landing/commercial-dark/slider-bg-2.jpg";
import SliderBG3 from "public/landing/commercial-dark/slider-bg-3.jpg";
import SliderBG4 from "public/landing/commercial-dark/slider-bg-4.jpg";
import SliderBG5 from "public/landing/commercial-dark/slider-bg-5.jpg";
import Asset1 from "public/landing/commercial-dark/multifam.png";
import Asset2 from "public/landing/commercial-dark/asset-2.png";
import Asset3 from "public/landing/commercial-dark/asset-3.png";
import Asset4 from "public/landing/commercial-dark/asset-4.png";
import Adv from "public/landing/commercial-dark/adv-1-2.png";
import Adv2 from "public/landing/commercial-dark/adv-2.png";
import Adv3 from "public/landing/commercial-dark/adv-3.png";
import Adv4 from "public/landing/commercial-dark/adv-4.png";
import NOI from "public/landing/commercial-dark/noi.png";
import Step1 from "public/landing/commercial-dark/step-1.svg";
import Step2 from "public/landing/commercial-dark/step-2.svg";
import Step3 from "public/landing/commercial-dark/step-3.svg";
import LeftQuote from "public/landing/commercial-dark/left-quote.svg";
import RightQuote from "public/landing/commercial-dark/right-quote.svg";
import Warehouse from "public/landing/commercial-dark/warehouse.svg";
import SwiperArrowRightMobile from "public/landing/commercial-dark/right-arrow-mobile.svg";
import SwiperArrowLeftMobile from "public/landing/commercial-dark/left-arrow-mobile.svg";
import SwiperArrowRight from "public/landing/commercial-dark/right-arrow.svg";
import SwiperArrowLeft from "public/landing/commercial-dark/left-arrow.svg";

import Sam from "public/about/team/SamSosa.jpg";
import Kim from "public/about/team/KimS.jpg";
import Chris from "public/about/team/ChrisE.jpg";
import Francis from "public/about/team/FrancisK.jpg";
import Kyle from "public/about/team/Kyle.jpg";

import GPS from "public/landing/commercial-dark/gps.svg";
import Target from "public/landing/commercial-dark/target.svg";
import Dollar from "public/landing/commercial-dark/dollar.svg";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import Marquee from "react-fast-marquee";
import MultiToggle from "elements/MultiToggle";
import { DynamicCommercialLandingPageProps } from "utils/types";

type SwiperCardProps = {
	titleImg: JSX.Element;
	title: string;
	body: string;
	signature: string;
	designation: string;
	assessmentReduction: string;
	variant: string;
	caseStudyLink: string;
};

type TaxConsultantCardProps = {
	headshot: StaticImageData;
	name: string;
	expertise: string;
	aum: string;
	appealWon: string;
	experience: string;
};

const SwiperCards = [
	{
		background: SliderBG,
		variant: "Testimonial",
		titleImg: <Warehouse />,
		title: "Warehouse",
		body: "Working with Ownwell was incredible! They slashed my warehouse’s assessed value from <span class='white'>$6.47 million to just under $2 million, saving me $65,000</span>. Now, I can focus on completing my project, knowing I won’t be blindsided by surprise tax hikes.",
		signature: "John Trial",
		designation: "Commercial Warehouse Owner",
		assessmentReduction: "69%",
		caseStudyLink:
			"https://www.ownwell.com/commercial-case-study/how-ownwell-saved-an-austin-developer-65560-in-property-taxes",
	},
	{
		background: SliderBG2,
		variant: "Testimonial",
		titleImg: <Warehouse />,
		title: "Industrial",
		body: "Ownwell is very easy to use and got us amazing reductions across our portfolio of properties! I barely have to lift a finger. We went with them for their competitive pricing and are very happy with the results and quality of service. We’ll keep using them for the foreseeable future!",
		signature: "Todd Ellis",
		designation: "Industrial Manufacturer",
		assessmentReduction: "74%",
		caseStudyLink:
			"https://www.ownwell.com/commercial-case-study/ownwell-12k-tax-cut-texas-industrial-property",
	},
	{
		background: SliderBG3,
		variant: "Case Study",
		titleImg: <Warehouse />,
		title: "Commercial Land",
		body: "In 2023, the owner of a roughly 6-acre narrow tract of commercially zoned vacant land near Austin Airport received a shocking assessment. The Travis Central Appraisal District (CAD) determined that the land value had soared from $175,000 in 2022 to $1,018,585 in 2023, marking a remarkable 482% increase.....",
		signature: "",
		designation: "",
		assessmentReduction: "82.8%",
		caseStudyLink:
			"https://www.ownwell.com/case-study/ownwell-cuts-assessment-after-land-value-increases-5x",
	},
	{
		background: SliderBG4,
		variant: "Case Study",
		titleImg: <Warehouse />,
		title: "Office Building",
		body: "A longtime real estate investor decided to move forward with appealing the new tax assessment with Ownwell for one of his office properties.<br>After his firm provided property-specific information, Ownwell was able to generate evidence supporting an assessment reduction of nearly $1.5M for the $8.8M property.",
		signature: "",
		designation: "",
		assessmentReduction: "16%",
		caseStudyLink:
			"https://www.ownwell.com/case-study/how-ownwell-earned-a-25-property-tax-reduction-for-an-8.8M-waterfront-office",
	},
	{
		background: SliderBG5,
		variant: "Case Study",
		titleImg: <Warehouse />,
		title: "Industrial",
		body: "Leveraging their strong working relationship with the Travis County Appraisal District, Ownwell engaged in an informal hearing. Presenting the evidence and negotiating with the appraiser, they reached an agreement on a final assessed value of $3.4 million, reflecting a 24% reduction and yielding a total tax savings of $21,167.",
		signature: "",
		designation: "",
		assessmentReduction: "24%",
		caseStudyLink:
			"https://www.ownwell.com/case-study/negotiation-skills-secure-significant-tax-reduction",
	},
];

const TaxConsultants: TaxConsultantCardProps[] = [
	{
		headshot: Sam,
		name: "Sam S.",
		expertise: "Tax appraisal, valuation, and tax forecasting, tax consulting",
		aum: "$30+ billion",
		appealWon: "10,000+",
		experience: "20",
	},
	{
		headshot: Francis,
		name: "Francis K.",
		expertise: "Tax appraisal, valuation, and tax consulting",
		aum: "$10+ billion",
		appealWon: "30,000+",
		experience: "25",
	},
	{
		headshot: Kim,
		name: "Kim S.",
		expertise: "Property tax law, tax valuation",
		aum: "$20+ billion",
		appealWon: "10,000+",
		experience: "15",
	},
	{
		headshot: Chris,
		name: "Chris E.",
		expertise: "Tax consulting, valuation",
		aum: "$15+ billion",
		appealWon: "15,000+",
		experience: "15",
	},
	{
		headshot: Kyle,
		name: "Kyle B.",
		expertise: "Commercial appeals, tax forecasting",
		aum: "$15+ billion",
		appealWon: "10,000+",
		experience: "2",
	},
];

const SwiperCard = ({ card }: { card: SwiperCardProps }) => {
	return (
		<div className="swiper-card">
			<div className="card-header">
				<p className="variant h4">{card.variant}</p>
				<div className="card-title">
					{card.titleImg}
					<p className="default">{card.title}</p>
				</div>
				<p className="reduction semibold">
					Assessment reduction: {card.assessmentReduction}
				</p>
			</div>
			<div className="card-body">
				{card.variant === "Testimonial" && (
					<div className="quote-left">
						<LeftQuote />
					</div>
				)}
				<div className="body-text">
					<p dangerouslySetInnerHTML={{ __html: card.body }}></p>
				</div>
				{card.variant === "Testimonial" && (
					<div className="quote-right">
						<RightQuote />
					</div>
				)}
			</div>
			<div className="card-signature">
				<p className="sm">{card.signature}</p>
				<p className="sm">{card.designation}</p>
			</div>
			<div className="case-study-link">
				<QuickLink
					size="extra-small"
					className="semibold azure"
					href={card.caseStudyLink}
					target="_blank">
					View Full Case Study
				</QuickLink>
			</div>
		</div>
	);
};

const TaxConsultantCard = ({
	consultant,
}: {
	consultant: TaxConsultantCardProps;
}) => {
	return (
		<div className="tax-consultant-card">
			<p className="experience">{consultant.experience} years of experience</p>
			<div className="consultant-headshot">
				<NextImage
					src={consultant.headshot}
					alt={consultant.name}
					style={{
						width: "100%",
						height: "auto",
					}}
				/>
			</div>
			<div className="consultant-info">
				<p className="consultant-name large bold">{consultant.name}</p>
				<div className="consultant-details">
					<div className="consultant-details-row">
						<GPS />
						<p className="consultant-expertise xs">
							Expertise: {consultant.expertise}
						</p>
					</div>
					<div className="consultant-details-row">
						<Dollar />
						<p className="consultant-aum xs">AUM: {consultant.aum}</p>
					</div>
					<div className="consultant-details-row">
						<Target />
						<p className="consultant-appeal-won xs">
							Appeals Won: {consultant.appealWon}
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};

const CommercialLandingDark = ({
	dynamicElements,
}: DynamicCommercialLandingPageProps) => {
	const router = useRouter();
	const trackEvent = useEventTracker();

	const { isMobile, isDesktop } = useResponsiveContext();

	const handleSignUpClick = () => {
		trackEvent({
			eventName: constants.EVENTS.Commercial_sign_up,
		});
		router.push("/appeal/portfolio?landing_page_source=commercial");
	};

	useEffect(() => {
		trackEvent({
			eventName: constants.EVENTS.commercial_landing_page_view,
		});
	}, []);

	const contactSectionRef = useRef<HTMLDivElement>(null);

	const onContactSalesCtaClick = () => {
		trackEvent({
			eventName: constants.EVENTS.Commercial_contact_sales,
		});
		if (contactSectionRef.current) {
			contactSectionRef.current.scrollIntoView({
				behavior: "smooth",
			});
		}
	};

	return (
		<div id="commercial-landing-dark">
			<div id="header-section">
				<MultiToggle />
				<div className="heading-content content-wrapper">
					<p>Commercial Property Tax Services</p>
					<h1>
						{dynamicElements?.heroTitle ??
							"Higher Savings on Commercial Property Taxes"}
					</h1>
					<p className="lg">
						{dynamicElements?.subTitle ??
							"Ownwell pairs local property tax advisors with advanced software to provide the best-in-class tax solution for commercial real estate investors."}
					</p>
				</div>
				<div className="header-bottom-wrapper content-wrapper">
					<div className="left-container">
						<div className="btns-container">
							{dynamicElements?.showSignupCta !== false && (
								<ButtonV2 size="default" onClick={handleSignUpClick}>
									Get Started
								</ButtonV2>
							)}
							{dynamicElements?.showTalkToSalesCta !== false && (
								<ButtonV2
									className="primary-outline white-outline"
									size="default"
									onClick={onContactSalesCtaClick}>
									Talk to Sales
								</ButtonV2>
							)}
						</div>
						<div className="trusted-by-container">
							<div className="trusted-by-imgs">
								<NextImage
									src={TrustedPeople}
									alt="Trusted By"
									style={{ width: "100px", height: "auto" }}
								/>
							</div>
							<div className="trusted-by-content">
								<div className="star-icon">
									<FiveStar />
								</div>
								<div className="trusted-by-text">
									<p className="trusted-by-title xs">
										Trusted by 10k+ Businesses
									</p>
								</div>
							</div>
						</div>
					</div>
					<div className="right-container">
						<div className="product-page-screenshot-container">
							{dynamicElements?.heroImage && (
								<img
									src={dynamicElements.heroImage.fields.file.url}
									alt={dynamicElements.heroImage.fields.description}
									style={{ width: "100%", height: "auto" }}
								/>
							)}
							{!dynamicElements?.heroImage && (
								<NextImage
									src={MockUpDesktop}
									alt="Mock Up"
									style={{ width: "100%", height: "auto" }}
								/>
							)}
						</div>
					</div>
				</div>
			</div>
			<div id="feature-rating-section">
				<div className="featred-in-container content-wrapper">
					<h3>As seen on</h3>
					<div className="featured-in-imgs">
						{isMobile ? (
							<Marquee>
								<FeaturedIn />
							</Marquee>
						) : (
							<FeaturedIn />
						)}
					</div>
				</div>
				<div className="rating-container content-wrapper">
					<div className="title-container">
						<h2>The #1 Rated Property Tax Service Company</h2>
						<div className="btns-container">
							<ButtonV2
								size="default"
								className="primary"
								onClick={handleSignUpClick}>
								Get Started
							</ButtonV2>
							<ButtonV2
								className="primary-outline white-outline"
								size="default"
								onClick={onContactSalesCtaClick}>
								Talk to Sales
							</ButtonV2>
						</div>
						<p className="subtext">No Hidden Fees | Only Pay if You Save</p>
					</div>
					<div className="rating-boxes">
						<div className="ratings-row">
							<div className="rating-box gap-0">
								<div className="value">
									<p className="h3">31.1%</p>
								</div>
								<div className="rating-text">
									<p className="small">More Savings than most Competitors</p>
								</div>
							</div>
							<div className="rating-box">
								<div className="value">
									<p className="h3">86%</p>
								</div>
								<div className="rating-text">
									<p className="small">Reduction Success Rate</p>
								</div>
							</div>
						</div>
						<div className="ratings-row">
							<div className="rating-box">
								<div className="value">
									<p className="h3">240K</p>
								</div>
								<div className="rating-text">
									<p className="small">Appeals Won Since 2021</p>
								</div>
							</div>
							<div className="rating-box">
								<div className="value">
									<p className="h3">$182B</p>
								</div>
								<div className="rating-text">
									<p className="small">Real Estate Managed</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			{dynamicElements?.showTestimonialsSection !== false && (
				<div id="slider-section">
					<div className="slider-container">
						<div className="swiper-btn-container content-wrapper">
							<div id="swiper-button-prev">
								{isMobile ? <SwiperArrowLeftMobile /> : <SwiperArrowLeft />}
							</div>
							<div id="swiper-button-next">
								{isMobile ? <SwiperArrowRightMobile /> : <SwiperArrowRight />}
							</div>
						</div>
						<div className="swiper-content-wrapper">
							<Swiper
								loop={true}
								cssMode={true}
								navigation={{
									nextEl: "#swiper-button-next",
									prevEl: "#swiper-button-prev",
								}}
								pagination={{
									el: "#swiper-pagination",
									clickable: true,
									renderBullet: function (_, className) {
										return (
											'<span class="' +
											className +
											' testimonial-section-pagination-bullet">' +
											"</span>"
										);
									},
								}}
								mousewheel={true}
								keyboard={true}
								modules={[Navigation, Pagination, Autoplay]}
								autoplay={{
									delay: 8000, // Time between slides in ms
									disableOnInteraction: false, // Continue autoplay after user interaction
								}}
								className="mySwiper">
								{SwiperCards.map((card, index) => {
									return (
										<SwiperSlide className="swiper-slide" key={index}>
											<div className="background-img-wrapper">
												<NextImage
													src={card.background}
													alt="Retail"
													style={{
														objectFit: "cover",
														objectPosition: "center",
														width: "100%",
														height: "100%",
													}}
												/>
											</div>
											<div className="swiper-card-wrapper content-wrapper">
												<SwiperCard card={card} />
											</div>
										</SwiperSlide>
									);
								})}
							</Swiper>
						</div>
						{isDesktop && <div id="swiper-pagination"></div>}
					</div>
				</div>
			)}
			{dynamicElements?.showAssetTypeSection !== false && (
				<div id="assets-section">
					<div className="content-wrapper">
						<h2 className="mb-3">
							Our Commercial Property Tax Consultants Specialize in Multiple
							Asset Types
						</h2>
						<div className="assets-cards">
							<div className="asset-card">
								<div className="asset-img">
									<NextImage
										src={Asset1}
										alt="Multi Family"
										layout="fill"
										objectFit="cover"
									/>
								</div>
								<div className="asset-text">
									<p className="xl">Multifamily</p>
								</div>
							</div>
							<div className="asset-card">
								<div className="asset-img">
									<NextImage
										src={Asset2}
										alt="Office"
										layout="fill"
										objectFit="cover"
									/>
								</div>
								<div className="asset-text">
									<p className="xl">Office</p>
								</div>
							</div>
							<div className="asset-card">
								<div className="asset-img">
									<NextImage
										src={Asset3}
										alt="Retail"
										layout="fill"
										objectFit="cover"
									/>
								</div>
								<div className="asset-text">
									<p className="xl">Retail</p>
								</div>
							</div>
							<div className="asset-card">
								<div className="asset-img">
									<NextImage
										src={Asset4}
										alt="Industrial"
										layout="fill"
										objectFit="cover"
									/>
								</div>
								<div className="asset-text">
									<p className="xl">Industrial</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			)}
			{dynamicElements?.showAdvantagesSection !== false && (
				<div id="advantages-section">
					<div className="advantage-header content-wrapper">
						<h3>The Ownwell Advantage</h3>
						<p className="subtitle">
							Unmatched results driven by cutting-edge technology and local
							experts
						</p>
						<div className="btns-container">
							<ButtonV2 onClick={handleSignUpClick} size="default">
								Get Started
							</ButtonV2>
							<ButtonV2
								className="primary-outline white-outline"
								size="default"
								onClick={onContactSalesCtaClick}>
								Talk to Sales
							</ButtonV2>
						</div>
					</div>
					<div className="advantage-content content-wrapper">
						<div className="advantage-card">
							<div className="advantage-img">
								<NextImage
									src={Adv}
									alt="White Glove Service"
									style={{
										width: "auto",
										height: isMobile ? "200px" : "250px",
										overflow: "hidden",
										borderRadius: "16px",
									}}
								/>
							</div>
							<div className="advantage-text">
								<h4>Increase NOI</h4>
								<p className="lg">
									Customers get 31.1% higher savings with Ownwell than other
									competitors on average.
								</p>
							</div>
						</div>
						<div className="advantage-card">
							<div className="advantage-img">
								<NextImage
									src={Adv2}
									alt="White Glove Service"
									style={{
										width: "auto",
										height: isMobile ? "200px" : "250px",
										overflow: "hidden",
										borderRadius: "16px",
									}}
								/>
							</div>
							<div className="advantage-text">
								<h4>Transparency</h4>
								<p className="lg">
									Receive real-time updates, track and manage all appeals and
									payments in one place.
								</p>
							</div>
						</div>
						<div className="advantage-card">
							<div className="advantage-img">
								<NextImage
									src={Adv3}
									alt="White Glove Service"
									style={{
										width: "auto",
										height: isMobile ? "200px" : "250px",
										overflow: "hidden",
										borderRadius: "16px",
									}}
								/>
							</div>
							<div className="advantage-text">
								<h4>White Glove Service</h4>
								<p className="lg">
									Dedicated tax professionals assigned to each client to provide
									tailored and attentive support.
								</p>
							</div>
						</div>
						<div className="advantage-card">
							<div className="advantage-img">
								<NextImage
									src={Adv4}
									alt="Save Time"
									style={{
										width: "auto",
										height: isMobile ? "200px" : "250px",
										overflow: "hidden",
										borderRadius: "16px",
									}}
								/>
							</div>
							<div className="advantage-text">
								<h4>Save Time</h4>
								<p className="lg">
									Automated software handles your workflow, freeing up time to
									focus on your business.
								</p>
							</div>
						</div>
					</div>
				</div>
			)}
			{dynamicElements?.showAppealProcessSection !== false && (
				<div id="appeal-process" className="content-wrapper">
					<h2 className="text-center denim-black">
						The Property Tax Appeal Process
					</h2>
					<div className="appeal-steps">
						<div className="appeal-step">
							<div className="step-img">
								<Step1 />
							</div>
							<p className="step-title extra-large">Building Your Case</p>
							<p className="step-text">
								Our software analyzes data from 100+ sources and our tax experts
								assess your situation to develop the best strategy for
								maximizing savings.
							</p>
						</div>
						<div className="appeal-step">
							<div className="step-img">
								<Step2 />
							</div>
							<p className="step-title extra-large">Representing Your Case</p>
							<p className="step-text">
								Our experts will file and advocate for your property with all
								relevant authorities, managing the process and keeping you
								updated in real time.
							</p>
						</div>
						<div className="appeal-step">
							<div className="step-img">
								<Step3 />
							</div>
							<p className="step-title extra-large">Litigation Support</p>
							<p className="step-text">
								If needed, Ownwell will pursue litigation to achieve the best
								outcome for your case, ensuring every avenue is explored for
								maximum savings.
							</p>
						</div>
					</div>
					<div className="noi-box">
						<div className="box-content">
							<div className="box-text">
								<h4>Increase Your NOI and Simplify Your Tax Process</h4>
								<p>No hidden fees. Only pay if you save.</p>
							</div>
							<div className="box-btns">
								<ButtonV2 onClick={handleSignUpClick} size="default">
									Get Started
								</ButtonV2>
								<ButtonV2
									onClick={onContactSalesCtaClick}
									className="primary-outline white-outline"
									size="default">
									Talk to Sales
								</ButtonV2>
							</div>
						</div>
						<div className="box-img">
							<NextImage
								src={NOI}
								alt="Save Time"
								style={{
									width: isMobile ? "100%" : "auto",
									height: isMobile ? "auto" : "250px",
									overflow: "hidden",
									borderRadius: "16px",
								}}
							/>
						</div>
					</div>
				</div>
			)}
			{dynamicElements?.showPTCSection !== false && (
				<div id="tax-consultants">
					<h3>Featured Commercial Property Tax Experts</h3>
					<div className="tax-consultants-slider">
						<Swiper
							slidesPerView={isMobile ? 1 : 4}
							observer
							resizeObserver
							observeParents
							loop={true}
							style={{ padding: "10px" }}
							className="consultant-swiper"
							modules={[Pagination, Navigation, Autoplay]}
							autoplay={{
								delay: 3000, // Time between slides in ms
								disableOnInteraction: false, // Continue autoplay after user interaction
							}}
							navigation={{
								nextEl: "#swiper-button-next-consultant",
								prevEl: "#swiper-button-prev-consultant",
							}}>
							{TaxConsultants.map((consultant, index) => {
								return (
									<SwiperSlide className="swiper-slide-consultant" key={index}>
										<TaxConsultantCard consultant={consultant} />
									</SwiperSlide>
								);
							})}
						</Swiper>
					</div>
					<div className="swiper-btn-container-consultant">
						<div id="swiper-button-prev-consultant">
							<SwiperArrowLeft />
						</div>
						<div id="swiper-button-next-consultant">
							<SwiperArrowRight />
						</div>
					</div>
				</div>
			)}
			{dynamicElements?.showCaseStudiesSection !== false && (
				<div id="case-study-section">
					<div className="content-wrapper">
						<CaseStudies caseStudiesType="commercial" />
					</div>
				</div>
			)}
			<div id="contact-section">
				<div className="content-wrapper">
					<Contact
						heading="Talk to Sales"
						subHeading="Fill out the form below to have a team member reach out."
						ref={contactSectionRef}
					/>
				</div>
			</div>
		</div>
	);
};

export default CommercialLandingDark;
